import nl_NL from "../i18n/nl_NL";
import en from "../i18n/en.js";
import fr from "../i18n/fr";
import { Locale } from "../Translate/Translate";

const nlLocale = new Locale("nl", "Nederlands", "NL", nl_NL);
const enLocale = new Locale("en", "English", "EN", en);
const frLocale = new Locale("fr", "Français", "FR", fr);

const createLocales = (): Locale[] => {
  return [nlLocale, enLocale, frLocale];
};

const i18n = {
  createLocales: () => createLocales(),
};

export default i18n;
